import React, { FC } from 'react';

type Props = {
  text: string;
  image?: string;
  className?: string;
};

const PageText: FC<Props> = ({ text, image, className = '' }) => {
  return (
    <div className={`h-[50vh] flex flex-col items-center justify-center gap-5 ${className}`}>
      {image ? <img src={image} className='w-[100px] h-[100px] object-cover' /> : null}
      <p>{text}</p>
    </div>
  );
};

export default PageText;
